export default "__VITE_ASSET__CuYXA3Sx__"